import * as React from "react";


import { DetailsList,  DetailsListLayoutMode,  SelectionMode } from 'office-ui-fabric-react/lib/DetailsList';
import { Label } from 'office-ui-fabric-react/lib/Label';
import {CSVLink} from 'react-csv';


import { Config } from './Config.js';
import { Azioni } from './classi/Azioni.js';
import { Session } from './classi/Session.js';
import { Utils } from './classi/Utils.js';

import './css/Site.css';
import './css/Fatture.css';

const sessione = new Session();
const azioni = new Azioni();
const config = new Config();
const utils = new Utils();

let _items: IDocument[] = [];
let _itemsDaEsportare: IDocument[] = [];

export class Documenti extends React.Component  {
    
    constructor(){
        super();
        this.state = {
            documenti:[],
            documentiDaEsportare:[],
            errorMessage: '',
            id_cliente: false,
            
            visualizza : '',
            visualizzaWarning : 'nascosto'
        };
        
        this._popolaDocumenti = this._popolaDocumenti.bind(this);
        this._onChangeFiltraDocumenti = this._onChangeFiltraDocumenti.bind(this);

    }
    
                        
    componentDidMount() {
        this._popolaDocumenti();
        utils.setBoxInfoCliente();
    }
    
    _onChangeFiltraDocumenti(event){
        
        this.setState({ documenti: event.target.value ? 
            _items.filter(i =>  ( i.NOMEREALE.toLowerCase().indexOf(event.target.value.toLowerCase() ) >-1) || 
                                ( i.DATA_UPLOAD.toLowerCase().indexOf(event.target.value.toLowerCase() )>-1) || 
                                ( i.CODICE_CONTRATTO.toLowerCase().indexOf(event.target.value.toLowerCase() )>-1) 
                         ) : _items });
    }
    
    _popolaDocumenti()
    {
        
        let request = new Request( config.get("anagrafica_documenti"),{
            method: 'POST', mode: 'cors', credentials: "include", 
            body: JSON.stringify({ id_cliente: sessione.get('id_cliente')  })
        });
        
        fetch(request)
        .then(function(response){
            return response.json();
        }).then(function(result){
            
            utils.gestisciMessaggio( result );
            
            if (result.success) {
            
                _items = [];
                _itemsDaEsportare = [];
                
                let visualizza= 'nascosto';
                let visualizzaWarning = 'warning centrato margin10';
                
                if( result.data !== null )
                {
                    
                    for( let tipo in result.data)
                    {
                        // Elenco dei documenti
                        if ( result.data[tipo].length > 0) {

                            visualizza= '';
                            visualizzaWarning = 'nascosto';

                            for (let i = 0; i < result.data[tipo].length; i++) {
                                
                                let tmp = result.data[tipo][i];
                                let itemDaEsportare = utils.jsonCopy( result.data[tipo][i] );

                                tmp['TIPO'] = tipo;
                                _items.push(tmp);
                                
                                delete itemDaEsportare.FILEPATH;
                                delete itemDaEsportare.ID_ALLEGATO;
                                delete itemDaEsportare.ID_TIPO_ALLEGATO;
                                delete itemDaEsportare.NOMEFILE;
                                delete itemDaEsportare.ID_CONTRATTO;
                                delete itemDaEsportare.ID_CONTRATTO;
                                
                                _itemsDaEsportare.push(itemDaEsportare);
                            }
                        }
                    }
                }
                this.setState({documenti: _items,documentiDaEsportare: _itemsDaEsportare, visualizza:visualizza, visualizzaWarning:visualizzaWarning });
   
            } else {
                this.setState({errorMessage: result.message, visualizza:'nascosto', visualizzaWarning:'warning centrato margin10'});
            }
        }.bind(this) );
    }
    
    
    render() {

        return (
        <div id="inner-container">
            <Label className='ms-fontSize-xxl titolo-pagina'>Documenti<span id='boxdettagliocliente'></span></Label>

            <div id='filtri'>
                <div className='boxsearch'>
                    <label className='ms-bgColor-themePrimary ms-font-m-plus'><span>Filtra per Documenti</span></label>

                    <div id='ricercapod'>
                        <div className="ms-ComboBoxCustomStyledExample">
                            Ricerca <br/>

                            <div className="ms-TextField-wrapper wrapper_df60a678">
                                <div className="ms-TextField-fieldGroup fieldGroup_df60a678">
                                    <input type="text" onChange={this._onChangeFiltraDocumenti} id="TextField81" className="ms-TextField-field field_df60a678 ms-font-m" />
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
             </div>
             
            <div>
                <div id="warning" className={this.state.visualizzaWarning}>Non sono disponibili documenti</div>

                <div id="elencorichieste" className={"DetailListContainer " + this.state.visualizza}>

                <div id="scarico" >
                <CSVLink data={this.state.documentiDaEsportare} separator={";"} filename={"elenco_documenti.csv"} className="btn btn-primary" target="_blank" ><div className="ms-BrandIcon--icon96 ms-BrandIcon--excel"></div><span>Scarica CSV</span></CSVLink>
                </div>

                <DetailsList
                    items={this.state.documenti}
                    columns={ azioni.restituisciColonneDocumenti() }
                    setKey="set"
                    layoutMode={DetailsListLayoutMode.justified}
                    selectionMode={SelectionMode.none}
                    selectionPreservedOnEmptyClick={true}
                    onItemInvoked={this._onItemInvoked}
                    compact={true}

                  />
                </div>
            </div>

            <div id="boxdialogo"></div>
 
        </div>
        );

    }
    
}
export default Documenti;


// WEBPACK FOOTER //
// ./src/AcComponents/Documenti.js